import { createAction } from "./home.actions";

// Simplified committee action creators using the factory function
export const getAffiliateBanner = createAction("/get_affiliates_banner");
export const getAffiliates = createAction("/list_affiliates");
export const getCommitteeFinanceBanner = createAction(
  "/get_commiitee_finance_banner",
);
export const getCommunityFinanceMembership = createAction(
  "/get_community_finance_membership",
);
